import type { HttpClient } from './http.js';

export interface UiSettingsRemote {
  theme?: 'light' | 'dark' | 'system';
  auto_advance?: boolean;
  sound_enabled?: boolean;
  notifications_enabled?: boolean;
}

export interface RemotePreferences {
  focus_duration: number;
  short_break_duration: number;
  long_break_duration: number;
  cycle_count: number;
  custom_sounds: Record<string, string>;
  ui_settings?: UiSettingsRemote;
}

export interface ProfileResponse extends RemotePreferences {
  id: string;
  email: string | null;
  isPremium: boolean;
}

export function createPreferencesApi(http: HttpClient) {
  return {
    fetchProfile(): Promise<ProfileResponse> {
      return http.json<ProfileResponse>('/api/profile/');
    },

    saveProfilePreferences(remote: Partial<RemotePreferences>): Promise<void> {
      return http.json('/api/profile/', {
        method: 'PUT',
        body: JSON.stringify(remote),
      });
    },

    fetchVisitorPreferences(visitorId: string): Promise<RemotePreferences & { visitor_id: string }> {
      return http.json(`/api/preferences/${encodeURIComponent(visitorId)}`);
    },

    saveVisitorPreferences(
      visitorId: string,
      remote: Partial<RemotePreferences>,
    ): Promise<void> {
      return http.json(`/api/preferences/${encodeURIComponent(visitorId)}`, {
        method: 'PUT',
        body: JSON.stringify(remote),
      });
    },

    checkPremiumStatus(visitorId: string): Promise<{ isPremium: boolean; userId?: string }> {
      return http.json('/api/premium/status', {
        method: 'POST',
        body: JSON.stringify({ visitor_id: visitorId }),
      });
    },
  };
}
